import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import styles from "styles/pages/Pages.module.scss";
import { useService } from "components/route/ServiceRoute";
import Filters from "components/Filters";
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import { RNHHospitalGet } from "services/services-mia/RNHHospitalGet";
import { RenderSection } from "./Components/RenderSection";
import { RenderCap } from "./Components/RenderCap";
import { RenderPosta } from "./Components/RenderPosta";
import { RenderPuesto } from "./Components/RenderPuesto";

const tree = [
    {id: 0, type: "section", patern: null, name: "Departamento 1"},
    {id: 1, type: "section", patern: null, name: "Departamento 2"},
    {id: 10, type: "cap", patern: null, name: "Caps 1"},
    {id: 11, type: "cap", patern: null, name: "Caps 2"},
    {id: 2, type: "division", patern: 0, name: "Division 1"},
    {id: 3, type: "division", patern: 0, name: "Division 2"},
    {id: 4, type: "division", patern: 1, name: "Division 3"},
    {id: 5, type: "division", patern: 1, name: "Division 4"},
    {id: 6, type: "unit", patern: 1, name: "Unit 1"},
    {id: 7, type: "unit", patern: 2, name: "unit 2"},
    {id: 8, type: "unit", patern: 4, name: "unit 3"},
    {id: 9, type: "unit", patern: 4, name: "unit 4"},
    {id: 12, type: "puesto", patern: null, name: "puesto 1"},
    {id: 13, type: "puesto", patern: 11, name: "puesto 2"},
    {id: 14, type: "posta", patern: null, name: "posta 3"},
    {id: 15, type: "posta", patern: 10, name: "posta 4"},
]

export default function EstructurasSalud() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const [hospitales, setHospitales] = useState([]);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [loading, setLoading] = useState(false);
    const [sections, setSections] = useState(tree.filter(e => e.type === "section" && e.patern === null));
    const [caps, setCaps] = useState(tree.filter(e => e.type === "cap" && e.patern === null));
    const [rootPuestos, setRootPuestos] = useState(tree.filter(e => e.type === "puesto" && e.patern === null));
    const [rootPostas, setRootPostas] = useState(tree.filter(e => e.type === "posta" && e.patern === null));
    const [expanded, setExpanded] = useState({});
    const [id, setId] = useState(null)
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const { service } = useService();

    const toggleExpand = (id, e) => {
        e.stopPropagation()
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const hanndleSelectId = (idSelect) => {
        if(idSelect === id){
            setId(null)
        } else {
            setId(idSelect)
        }
    }

    const getChildren = (parentId, childType) => {
        return tree.filter(item => item.patern === parentId && item.type === childType);
    };

    const calculateElementRows = (element) => {
        let rows = 1;
        
        if (!expanded[element.id]) return rows;

        if (element.type === "section") {
            const divisions = getChildren(element.id, "division");
            const directUnits = getChildren(element.id, "unit");
            
            divisions.forEach(div => {
                const units = getChildren(div.id, "unit");
                rows += expanded[div.id] ? units.length : 1;
            });
            rows += directUnits.length;
        } else if (element.type === "cap") {
            const postas = getChildren(element.id, "posta");
            const directPuestos = getChildren(element.id, "puesto");
            
            postas.forEach(pos => {
                const puestos = getChildren(pos.id, "puesto");
                rows += expanded[pos.id] ? puestos.length : 1;
            });
            rows += directPuestos.length;
        } else if (element.type === "division") {
            const units = getChildren(element.id, "unit");
            rows += expanded[element.id] ? units.length : 1;
        } else if (element.type === "posta") {
            const puestos = getChildren(element.id, "puesto");
            rows += expanded[element.id] ? puestos.length : 1;
        }
        
        return rows;
    };

    const calculateRowStart = (allElements, currentIndex) => {
        if (currentIndex === 0) return 1;
        
        return allElements
            .slice(0, currentIndex)
            .reduce((acc, element) => acc + calculateElementRows(element), 1);
    };

    const formik = useFormik({
        initialValues: {
            hospitalId: "",
        },
        onSubmit: (values) => {
            getHospitalesData(values)
        },
    })
    const resetForm = () => {
        formik.setFieldValue("hospitalId", "");
        getHospitalesData({})
    };

    const getHospitalesData = async (data = { hospitalId: null }) => {
        setLoading(true);
        const filter = await RNHHospitalGet(credentials);
        setHospitales(filter);
        setLoading(false);
    }
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getHospitalesData()
    }, [])
    useEffect(() => {
        setRoute({
            wordKey: `Estructuras - Programa Salud RN`
        })
    }, [service.servicioNombre, setRoute])

    const allRootElements = [
        ...sections,
        ...caps,
        ...rootPuestos,
        ...rootPostas
    ];
    
    return (
        <main className={styles.mainScroll}>
            <Modal open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        user={rowSelected.row}
                        updateList={getHospitalesData}
                        closeModal={closeModal}
                        filtro={hospitales}
                    />
                )}
                {modalDetails.procede === ACTIONS.EXPORT && (
                    <DeleteModal
                        user={rowSelected.row}
                        servicio={service}
                        updateList={getHospitalesData}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                        filtro={hospitales}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={getHospitalesData}
                        closeModal={closeModal}
                        filtro={hospitales}
                    />
                )}
            </Modal>
            <div className={styles["filters-actions"]}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Filters
                        formik={formik}
                        inputsRender={
                            [
                                { type: "select", name: "hospitalId", label: "Hospital", disabled: false, options: hospitales, firtsOptionKey: "rnhHospitalId", firstOptionName: "rnhHospitalNombre", firstOptionValue: "rnhHospitalId", all:false },
                            ]
                        }
                        disabled={loading}
                    />
                    <HeaderButton text={"Borrar filtros"} onClick={() => resetForm()} disabled={loading} ><FilterAltOffRoundedIcon /></HeaderButton>
                </div>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getHospitalesData() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Nueva area"}
                        handleClick={handleClick}
                        data={{
                            title: "Nueva area",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Modificar area"}
                        handleClick={handleClick}
                        data={{
                            title: "Modificar area",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar area"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar area",
                            procede: ACTIONS.EXPORT
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <DeleteOutlineRoundedIcon />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={styles.containerScroll}>
                <div className={styles.containerGral}>
                    <div className={styles.gridTreeWrapper}>
                        <div className={styles.gridTreeHeaders}>
                            <div className={styles.headerCell}>Departamentos</div>
                            <div className={styles.headerCell}>Divisiones</div>
                            <div className={styles.headerCell}>Unidades</div>
                            <div className={styles.headerCell}>Caps</div>
                            <div className={styles.headerCell}>Puestos</div>
                            <div className={styles.headerCell}>Postas</div>
                        </div>
                        <div className={styles.gridTree}>
                            {sections.map((section, idx) => 
                                RenderSection(section, allRootElements, allRootElements.findIndex(el => el.id === section.id), expanded, toggleExpand, getChildren, calculateElementRows, calculateRowStart, hanndleSelectId, id)
                            )}
                            {caps.map((cap, idx) => 
                                RenderCap(cap, allRootElements, allRootElements.findIndex(el => el.id === cap.id), getChildren, toggleExpand, expanded, calculateElementRows, calculateRowStart, hanndleSelectId, id)
                            )}
                            {rootPuestos.map((puesto, idx) => 
                                RenderPuesto(puesto, calculateRowStart(allRootElements, allRootElements.findIndex(el => el.id === puesto.id)), hanndleSelectId, id)
                            )}
                            {rootPostas.map((posta, idx) => 
                                RenderPosta(posta, calculateRowStart(allRootElements, allRootElements.findIndex(el => el.id === posta.id)), getChildren, hanndleSelectId, toggleExpand, expanded, id)
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}